import React from 'react'
import LineTagAltIcon from 'components/Luxkit/Icons/line/LineTagAltIcon'
import LineGlobeAltIcon from 'components/Luxkit/Icons/line/LineGlobeAltIcon'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import LineGlassMartiniAltIcon from 'components/Luxkit/Icons/line/LineGlassMartiniAltIcon'
import LineRefundIcon from 'components/Luxkit/Icons/line/LineRefundIcon'
import { ValueSectionItem } from 'home/components/ValuePropositionBanner/ValuePropositionItems'

export const uspContent = (regionCodeContext: string): ValueSectionItem[] => {
  return [
    {
      key: 'save',
      icon: <LineTagAltIcon size="S" />,
      headingI18Key: 'saveTitle',
      bodyI18Key: 'saveText',
    },
    {
      key: 'bonus',
      icon: <LineGlassMartiniAltIcon size="S" />,
      headingI18Key: 'bonusTitle',
      bodyI18Key: 'bonusText',
    },
    {
      key: 'oneStop',
      icon: <LineGlobeAltIcon size="S" />,
      headingI18Key: 'oneStopTitle',
      bodyI18Key: 'oneStopText',
    },
    {
      key: 'flexible',
      icon: <LineRefundIcon size="S" />,
      headingI18Key: 'flexibleTitle',
      bodyI18Key: 'flexibleText',
    },
    {
      key: '24hrService',
      icon: <LinePhoneIcon size="S" />,
      headingI18Key: regionCodeContext === 'IN' ? '24hrServiceTitleIndia' : '24hrServiceTitle',
      bodyI18Key: regionCodeContext === 'IN' ? '24hrServiceTextIndia' : '24hrServiceTextIndia',
    },
  ]
}
